export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11095.e410f748.jpg";